import { FORMAT_TEXT_COMMAND, TextFormatType } from 'lexical';
import React from 'react';
import { KeyValueMap } from '../KeyValueMap';
import { ActionType } from '../components/ActionType';
import ResponsiveToolbar from '../components/ResponsiveToolbar';
import { Icons } from '../icons/Icons';

export const textStyles: KeyValueMap<string, ActionType> = {
    bold: { label: 'lexical.format.bold', icon: Icons.FormatBold },
    italic: { label: 'lexical.format.italic', icon: Icons.FormatItalic },
    strikethrough: { label: 'lexical.format.strikethrough', icon: Icons.FormatStrikethrough },
    underline: { label: 'lexical.format.underline', icon: Icons.FormatUnderline }
};

export default function TextStyleMenuItem({
    disabled,
    isSmall,
    editor,
    isBold,
    isItalic,
    isStrikethrough,
    isUnderline
}) {
    const handleFormatting = (newFormatting: string[] | null) => {
        if (newFormatting && newFormatting.length) {
            if (Array.isArray(newFormatting)) {
                newFormatting.forEach((cmd) => {
                    editor.dispatchCommand(FORMAT_TEXT_COMMAND, cmd as TextFormatType);
                });
            } else {
                editor.dispatchCommand(FORMAT_TEXT_COMMAND, newFormatting as TextFormatType);
            }
        }
    };

    const selected = [];
    if (isBold) selected.push('bold');
    if (isItalic) selected.push('italic');
    if (isStrikethrough) selected.push('strikethrough');
    if (isUnderline) selected.push('underline');

    return (
        <ResponsiveToolbar
            disabled={disabled}
            multi={true}
            isSmall={isSmall}
            options={textStyles}
            onSelect={handleFormatting}
            selected={selected}
            icon={Icons.FormatColorText}
        />
    );
}
